{
  "import_layer": {
    "title": "Importer une couche",
    "confirm": "Importer des couches"
  },
  "data_fields": {
    "title": "Attributs",
    "add": "Ajouter un attribut",
    "project_data_fields": "Attribut prédéfini",
    "custom_data_field": "Attribut personnalisé",
    "type": "Tapez",
    "name": "Nom de l'attribut",
    "list_name": "Nom de la liste",
    "list_items": "Éléments de la liste",
    "list_item": "Élément de liste",
    "types": {
      "Text": "Texte",
      "List": "Liste",
      "Number": "Numéro",
      "Date": "Date",
      "Tickbox": "Case à cocher",
      "Time": "Heure",
      "TimeRange": "Échelle de temps",
      "Image": "Image",
      "Hyperlink": "Lien hypertexte",
      "RepeatedTimeRanges": "Plages de dates et d'heures"
    },
    "data_driven_formula": {
      "title": "Créer une nouvelle formule",
      "label": "Déterminez {{ styleProperty }} par",
      "addListItem": "Ajouter un élément de liste",
      "searchListItem": "Rechercher un élément de liste"
    }
  },
  "saved_map_view": {
    "default_label": "Définissez cette vue comme affichage par défaut du plan.",
    "default_description": "Cela définit l'image miniature du plan et charge cette vue pour tous les utilisateurs lorsqu'ils ouvrent le plan.",
    "form_header": "Donnez un nom à cette vue enregistrée",
    "name_label": "Nom de la vue enregistrée",
    "create_saved_view": "Création d'une vue enregistrée",
    "create_new_saved_view": "Créer une nouvelle vue enregistrée",
    "edit_saved_view": "Modifier la vue enregistrée",
    "move_map_around": "Déplacez le plan jusqu'à ce que vous soyez satisfait de la nouvelle vue.",
    "save_view_when_ready": "Lorsque vous êtes prêt, appuyez sur « Enregistrer les modifications » pour enregistrer la vue.",
    "map_default": "plan par défaut"
  },
  "create_map": {
    "create_map": "Créer un plan",
    "create_a_map": "Créez un plan",
    "modal_label": "Nom du plan",
    "create_a_new_map": "Créez un nouveau plan"
  },
  "buttons": {
    "new_layer": "Nouvelle couche",
    "import_layer": "Importer une couche",
    "site_map": "Plan du site",
    "background": "Contexte",
    "create_layer": "Créer une couche",
    "cancel": "Annuler",
    "share_table": "Partager le tableau",
    "download_table": "Télécharger le tableau",
    "toggle_sidebar": "Basculer la barre latérale",
    "columns_displayed": "Colonnes affichées",
    "closePopup": "Fermer la fenêtre contextuelle",
    "openBasemapSelector": "Ouvrir le sélecteur de fond de carte",
    "removeSiteMap": "Supprimer le plan du site de la vue"
  },
  "labels": {
    "object": "Objet",
    "object_id": "ID de l'objet",
    "object_name": "Nom de l'objet",
    "layer": "Couche",
    "zone": "Zone",
    "zones": "Zones",
    "client_group": "Groupe de clients"
  },
  "nav": {
    "layers": "couches",
    "data_table": "Tableau de données",
    "sitemap": "Plan du site",
    "background": "Contexte",
    "basemap": "Fond de carte",
    "background_maps": "Cartes d'arrière-plan",
    "selectSitemap": "Sélectionnez le plan du site",
    "selectLevel": "Sélectionnez le niveau",
    "search": "Rechercher"
  },
  "popup": {
    "view_by_layer": "Afficher par couche",
    "view_by_data_field": "Afficher par champ de données",
    "view_by_object": "Afficher par objet",
    "sitemapsAvailableAtThisLocation": "Plans du site disponibles à cet endroit",
    "closeSitemapSelector": "Fermer le sélecteur de plan du site",
    "sitemapLevels": "Niveaux du plan du",
    "closeLevelSelector": "Fermer le sélecteur de niveau",
    "saved_map_views": "Vues enregistrées"
  },
  "add_layer": {
    "create_a_new_layer": "Création d'une nouvelle couche",
    "new_layer": "Nouvelle couche",
    "name_of_layer": "Nom de la couche",
    "layer_style": "Style de couche",
    "layer_style_desc": "Choisissez un type de dessin ou sélectionnez un modèle de style",
    "drawing_type": "Type de dessin",
    "area": "Région",
    "lines": "Lignes",
    "points": "Points",
    "text_labels": "Étiquettes de texte",
    "templates": "Modèles",
    "shape_and_colour": "Forme et couleur",
    "line_colour": "Couleur de la ligne",
    "fill_opacity": "Opacité complète",
    "preview": "Aperçu",
    "width": "Largeur",
    "offset": "Offset",
    "zones": "Zones",
    "list_of_options": "Liste des options",
    "layer_design": "Conception des couches",
    "layer_templates": "Modèles de couches",
    "view_all_templates": "Afficher tous les modèles de couches",
    "scratch": "Commencer une couche à partir de zéro",
    "save_layer": "Enregistrer la couche",
    "type_of_layer": "Type de couche",
    "styles": "Styles",
    "save_style": "Enregistrer le style",
    "more": "Plus",
    "Line": "Ligne",
    "Icon": "Icône",
    "Point": "Point",
    "Area": "Région",
    "layer_being_created": "La couche est en cours de création..."
  },
  "measurements": {
    "unit_of_measurement": "Unité de mesure",
    "imperial": "Impérial",
    "metric": "Métrique"
  },
  "sidebar": {
    "node_name": "Le nom doit comporter au moins 2 caractères"
  },
  "import_layers_tooltip": {
    "Layer": "La couche existe déjà dans ce plan"
  },
  "search": {
    "search_map": "Rechercher",
    "locations": "Localisations",
    "objects": "Objets",
    "search_description": "Rechercher un lieu, une vue enregistrée, un objet",
    "saved_map_view": "Vues enregistrées",
    "no_results": "Aucun résultat ne correspond à votre recherche",
    "sitemaps": "Plans du site"
  }
}